export default __webpack_public_path__ + "static/media/ulu_icon.710a349d.png";